import {useAppForm} from '@/providers/components/formProvider';

import FormInput from '@/components/form/FormInput';

type FormFieldsPropsT = {
  formId: string;
  tabIndex?: number;
};

function FormFields({formId, tabIndex}: FormFieldsPropsT) {
  const {
    getStepFields,
    state: {loading},
  } = useAppForm({formId, enabled: true});

  if (loading) return null;

  return getStepFields().map((field, index) => (
    <FormInput key={`${field.name}_${index}`} field={field} tabIndex={tabIndex ? tabIndex + index : undefined} />
  ));
}

export default FormFields;
